export default __webpack_public_path__ + "8c3884d4c984441bdb162354066ebbb0.svg";